import { render, staticRenderFns } from "./TwinBed.vue?vue&type=template&id=3e25812c"
import script from "./TwinBed.vue?vue&type=script&lang=js"
export * from "./TwinBed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports